var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":"","color":"white","height":"40px","width":"100%"}},[_c('div',[_c('v-img',{attrs:{"src":require('@/assets/img/hourglass-empty.svg'),"width":"16"}}),_c('span',{staticClass:"font_14 pr-3"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }